import { gql } from '@apollo/client';

// Marca o desmarca varias órdenes. Va por la cola offline (sin skipOfflineQueue).
export const SET_ORDER_FLAGS = gql`
  mutation SetOrderFlags($orderIds: [ID!]!, $flagged: Boolean!, $changedAt: Date) {
    setOrderFlags(orderIds: $orderIds, flagged: $flagged, changedAt: $changedAt) {
      orderId
      flagged
      changedAt
      entityType
      entityId
    }
  }
`;
